import type { FaireProductEntity } from "../../entity_types/product";

export const p_wjz67mpm5w: FaireProductEntity = {
  token: "p_wjz67mpm5w",
  type: "product",
  name: "Three CZ Stud",
  brandToken: "b_7sddd34i",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/3e7fe0b009949d045de98e314cf3fb313286c43adf01a31e5ad8b283836ad94b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6b5fbff07059160b936b7b1dfb2b832ee033bf15b0ae96a8e5e6ee9625f3f754.jpeg",
    "https://cdn.faire.com/fastly/546d393af3b9d50ffda6ff99ea90e490a66c4dd7e797bfebae795a3a31ed131d.jpeg",
  ],
  priceDollars: 24.25,
  description:
    "Add a touch of sparkle with our Three CZ Stud. This playful yet meaningful piece is the perfect surprise for any occasion. Accented with three dazzling CZ stones, it's subtle yet eye-catching. Don't miss out on this dainty must-have!\n\nMaterial: Gold or Silver-Plated Brass, Cubic Zirconia \nStyle No. PE-6908",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:26:48.713Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
